export default {
    label: 'Check if you are affiliated with the U.S. Military'
}